<script setup lang="ts">
import PaymentTimerService from "@/services/operations/payment/PaymentTimerService";
import { computed } from "vue";
import { BuyingOperationStatus } from "@enums/BuyingOperationStatus";
import PurchaseOperation from "@models/operations/PurchaseOperation";
import {useI18n} from "vue-i18n";

interface Emits {
	(e: 'back'): void;
}

interface Props {
	payment: PurchaseOperation,
	timerService: PaymentTimerService,
}

const props = defineProps<Props>();

const emits = defineEmits<Emits>();

const { t } = useI18n();

const handleBack = () => {
	emits('back');
}

const percent = props.timerService.getPercent;
const timeText = props.timerService.getTimeText;
const showPaymentTimes = computed(() => {
	return !!(props.payment &&
		props.payment.status && [
			BuyingOperationStatus.EMPTY,
			BuyingOperationStatus.EXPIRED,
		].includes(props.payment.status) && props.timerService.ready.value &&
		percent.value
	);
});
</script>

<template>
	<f7-navbar class="create-payment-navbar">
		<f7-nav-left>
			<a href="#" class="create-payment-navbar__back" @click="handleBack">
				<i class="icon svg-arrow-left svg-filter-ACB4BE" />
				{{ t('light-payment.create.return-button') }}
			</a>
		</f7-nav-left>
		<f7-nav-right>
			<p v-if="showPaymentTimes && timeText" class="create-payment-navbar__timer">{{percent > 0 ? timeText : '0:00'}}</p>
		</f7-nav-right>
	</f7-navbar>
</template>

<style scoped lang="scss">
.create-payment-navbar {
	&__back {
		display: flex;
		align-items: center;
		gap: 0.5rem;

		@include text(14px, 500, #ACB4BE, 120%);
	}

	&__timer {
		@include text(16px, 500, #ACB4BE, 120%);
	}

	&:deep(.navbar-bg) {
		background-color: var(--white1);

		&::after {
			content: none;
		}
	}

	&:deep(.navbar-inner) {
		padding: 0 1rem;
	}
}
</style>
